import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const ReportSearchBarSchema = yup.object({
  group: yup.object().required(
    t('errors.required', {
      label: t('dashboard.header.actions.search.fields.group'),
    }),
  ),
  period: yup
    .array()
    .of(yup.date())
    .required(
      t('errors.required', {
        label: t('dashboard.header.actions.search.fields.period'),
      }),
    )
    .test('range-less-than-two-month', t('dashboard.header.actions.search.errors.range_less_than_two_month'), (value) => {
      const start = value[0]!
      const end = value[1]!

      return end.getTime() - start.getTime() < 1000 * 60 * 60 * 24 * 62
    }),
})

export default ReportSearchBarSchema
